import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=670c8258&"
import script from "./Help.vue?vue&type=script&lang=js&"
export * from "./Help.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1284950368/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('670c8258')) {
      api.createRecord('670c8258', component.options)
    } else {
      api.reload('670c8258', component.options)
    }
    module.hot.accept("./Help.vue?vue&type=template&id=670c8258&", function () {
      api.rerender('670c8258', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/icons/Help.vue"
export default component.exports